import { FieldRenderProps } from '@progress/kendo-react-form';
import { FieldWrapper } from 'components';

export type FieldInputProps = {
    child: React.ComponentType<any>
} & FieldRenderProps;

export const FieldInput = ({ ariaLabelledBy, child: Component, id, label, ...props }: FieldInputProps) => (
    <FieldWrapper label={label} {...props}>
        <Component
            id={id ?? props.name}
            aria-required={props.required}
            ariaLabelledBy={ariaLabelledBy ?? (label && `${props.name}_label`)}
            aria-live="assertive"
            {...props}
        />
    </FieldWrapper>
);